import { observable, action, computed, makeObservable, toJS } from 'mobx';
import qs from 'qs';
import { setClientHeaders } from '@/utils/ajax/clientAjax';

export const queryObj = qs.parse(window.location.search.replace(/^\?/, ''));

export interface LanguageSetting {
  language: string;
  language2: string;
  translateTargetLanguage: string;
}

const languageDefalut = (function () {
  let language = 'zh-CHS';
  if (queryObj.locale) {
    switch (queryObj.locale?.split?.('-')[0]) {
      case 'zh':
        language = 'zh-CHS';
        break;
      case 'en':
        language = 'en';
        break;
      case 'ja':
        language = 'ja';
        break;
      default:
        language = 'en';
    }
  }
  return language;
})();

class Info {
  constructor() {
    makeObservable(this);
  }

  @observable qtReady = true;

  @observable token = '';

  @observable meetingInfo: defs.client.MeetingTheBriefInformation | null = null;

  @observable meetingId = queryObj.meetingId || 23748676;

  // fg配置结果
  @observable settingFeature: string[] = [];

  @observable languageSetting: LanguageSetting = {
    language: languageDefalut,
    language2: 'auto',
    translateTargetLanguage: '',
  };

  // 转换翻译设置结果，翻译时为自动
  @computed
  get languageSettingParams() {
    const { translateTargetLanguage, language, language2 } = this.languageSetting;
    return {
      language: translateTargetLanguage ? language2 || 'auto' : language,
      translateTargetLanguage,
      translate: !!translateTargetLanguage,
    };
  }

  @action
  setLanguageSettingObj(set: LanguageSetting): any {
    this.languageSetting = set;
  }

  /*
调整联动逻辑：开启翻译后，原选择框禁用逻辑取消，调整为 “自动识别（默认选项，增加 beta 标签）”，支持手动调整为现有的中、英、日 三种识别源语言
  1. 自动识别：自动识别当前语种，并输出实时翻译
  2. 中 / 英 / 日手动设置：将当前接受到的音频流全部按照该语言处理并输出实时翻译内容
  3. 删除原开启翻译后小字部分：开启翻译后将自动识别语言，不做其他处理
  4. 关闭翻译后，该 “自动识别” 选项消失，调整为用户上一个选择的语言，并继续进行字幕识别
  5. 是否记忆用户选择：记忆，如果用户手动选择过源语言，则在开启翻译下保留该手动配置项，不开翻译的时候仍保留识别下的配置项
  */

  @action
  setLanguageSetting(key: string, value: string): any {
    switch (key) {
      case 'language':
        if (this.languageSetting.translateTargetLanguage) {
          this.languageSetting.language2 = value;
        } else {
          this.languageSetting.language = value;
        }
        break;
      case 'translateTargetLanguage':
        this.languageSetting.translateTargetLanguage = value;
        break;
      default:
    }
  }

  @action
  setQtReady(value: boolean) {
    this.qtReady = value;
  }

  @action
  updateToken(token: string): any {
    this.token = token;
    setClientHeaders({ Authorization: token });
  }

  @action
  getMeetingInfo(): any {
    if (this.token) {
      API.client.meetingV3.getBriefInfo.request({ meetingId: this.meetingId }).then(res => {
        if (res.status === 1 && res.data) {
          if (res.data?.beginTime?.match('T') && !res.data?.beginTime?.match(/[+-]08:00$/)) {
            res.data.beginTime = new Date(`${res.data?.beginTime}+08:00`).getTime();
          }
          this.meetingInfo = res.data;
        }
      });
      API.client.settingV3.getAvailableFeatures.request({}).then(res => {
        if (res?.data) {
          this.settingFeature = res.data;
        }
      });
    }
  }

  @computed
  get ableChangeLanguage() {
    return this.settingFeature.includes('transcript_license');
  }
}

export default Info;
